import React from 'react';
import jwtDecode from 'jwt-decode';
import api from 'api';
import { ListingObjects, Modal, DatePicker } from 'hyperdb-utils';
import { DEFAULT_LANGUAGE, FILESTORE_URL } from '../../config';

export default function({
  collectionName, namespace, mountedUrl, columns, title,
  canCreate = true, canEdit = true, canDelete = true, canShow = false, canExportCsv = false, batchPrint = false,
  customApi = null, CustomComponent = null, onNew = null, onEdit = null, onDelete = null,
  useQuickSearch = false, filters = null, defaultSort = null, advancedFilters = null, defaultLanguage = DEFAULT_LANGUAGE || 'en',
  actions = null,
}) {
  class HyperdbListing extends React.Component {
    constructor(props) {
      super(props);
      this.api = this.props.api[namespace];
      this.handleClickNew = this.handleClickNew.bind(this);
      this.handleClickEdit = this.handleClickEdit.bind(this);
      this.handleClickShow = this.handleClickShow.bind(this);
      this.handleClickAdvancedFilters = this.handleClickAdvancedFilters.bind(this);
      this.confirmBatchPrint = this.confirmBatchPrint.bind(this);
      this.handleChangeUntilDate = this.handleChangeUntilDate.bind(this);
      this.state = {
        showModalBatchPrint: false,
        until: null,
      };
    }
    componentDidMount() {
      if (advancedFilters) {
        Object.keys(advancedFilters).forEach(filterName => {
          const filter = advancedFilters[filterName];
          if (filter.type === 'relation' && filter.fetchData) {
            filter.fetchData(this.props);
          }
        });
      }
    }
    render() {
      const Listing = CustomComponent ? CustomComponent : ListingObjects;
      return (
        <div>
          <Listing
            { ...this.props }
            defaultLanguage={ defaultLanguage }
            collectionName={ collectionName }
            title={ title }
            mountedUrl={ mountedUrl }
            onNew={ canCreate ? this.handleClickNew : null }
            canEdit={ canEdit }
            onEdit={ this.handleClickEdit }
            canDelete={ canDelete }
            onDelete={ onDelete ? onDelete : this.api.deleteObject }
            canShow={ canShow }
            onShow={ canShow ? this.handleClickShow : null }
            onClickCsv={ canExportCsv ? this.api.downloadCsv : null }
            onBatchPrint={ batchPrint ? this.toggleModalBatchPrint.bind(this, true) : null }
            columns={ columns }
            onDismissAlert={ this.api.dismissAlert }
            actions={ actions }
            fetchListing={ this.api.fetchListing }
            useQuickSearch={ useQuickSearch }
            filters={ filters }
            defaultSort={ defaultSort }
            initialAdvancedFilters={ advancedFilters }
            onClickAdvancedFilters={ this.handleClickAdvancedFilters }
            onLeaveListing={ this.api.leaveListing }
          />
          {
            this.state.showModalBatchPrint
              ? <Modal title="Print reservations not printed" onClose={ this.toggleModalBatchPrint.bind(this, false) } onAccept={ this.confirmBatchPrint }>
                  <DatePicker
                    label="Reservations created before (included)"
                    name="until"
                    value={ this.state.until }
                    onChange={ this.handleChangeUntilDate.bind(this) }
                  />
                </Modal>
              : null
          }
        </div>
      );
    }

    handleClickNew() {
      if (onNew) return onNew(this.props);
      const url = `${mountedUrl}/new`;
      this.props.api.routing.redirect(this.props.router, url);
    }
    handleClickEdit(object) {
      if (onEdit) return onEdit(object, this.props);
      const url = `${mountedUrl}/${object.id}`;
      this.props.api.routing.redirect(this.props.router, url);
    }
    handleClickShow(object) {
      const url = `${mountedUrl}/${object.id}`;
      this.props.api.routing.redirect(this.props.router, url);
    }
    handleClickAdvancedFilters(useAdvancedFilters) {
      this.api.setData({ useAdvancedFilters });
    }

    toggleModalBatchPrint(bool) {
      this.setState({ showModalBatchPrint: bool, until: null });
    }
    handleChangeUntilDate({ value }) {
      this.setState({ until: value });
    }
    confirmBatchPrint() {
      const { currentUser } = this.props.api.getState('auth');
      const decoded = jwtDecode(currentUser.jwt);
      let url = `${FILESTORE_URL}/${decoded.client_id}/reservations/pdfs-for-not-printed?set_printed=true`;
      if (this.state.until) url += `&until=${this.state.until}`;
      window.open(url, '_blank');
    }
  }
  HyperdbListing.propTypes = {
    api: React.PropTypes.object,
    router: React.PropTypes.object,
    deleteSuccessful: React.PropTypes.bool,
  };

  const _api = !customApi ? api : customApi;
  return _api.connect(HyperdbListing, namespace);
}



// WEBPACK FOOTER //
// ./src/frontend/hyperdb/HyperdbListing.jsx